Drupal.behaviors.content_gallery = {
  attach: function (context, settings) {
   'use strict';

    jQuery(function() {

      jQuery('.content-gallery', context).each(function(index) {
        let gallery_wrapper = jQuery(this);
        let main_gallery = jQuery('.content-gallery_main', gallery_wrapper);
        let thumb_gallery = jQuery('.content-gallery_nav', gallery_wrapper);
        let galleryLength = main_gallery.children().length;

        // Add IDs to each gallery
        gallery_wrapper.attr('id', 'slickwrapper-' + index);

        // Create mobile nav and counter wrapper
        let mobile_controls = jQuery('<div class="mobile-controls"></div>');
        mobile_controls.insertAfter(main_gallery);

        // Create counter wrapper and set a default
        let counter = jQuery('<div class="counter">1/' + galleryLength + '</div>');
        counter.appendTo(mobile_controls);

        // Change counter before slider change
        main_gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          counter.html(nextSlide+1 + '/' + galleryLength)
        });

        main_gallery.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          infinite: false,
          asNavFor: '#slickwrapper-' + index + ' .content-gallery_nav',
          appendArrows: jQuery('.mobile-controls', gallery_wrapper),
          responsive: [
            {
              breakpoint: 656,
              settings: {
                fade: false,
              }
            }
          ]
        });

        thumb_gallery.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '#slickwrapper-' + index + ' .content-gallery_main',
          focusOnSelect: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 500,
              settings: "unslick"
            }
          ]
        });
      });

    });
  }
}
